export const HIGH_REFINE_TOWN = "emberhold";
export const HIGH_REFINE_FROM = 8;
export const WING_TOWN = "skyhaven";
export const WING_REFINE_FROM = 5;
export const ENDGAME_TOWN = "dawnrest";
/** ตีบวกช่อง `slot` ขึ้นเป็น `targetLevel` ที่เมืองนี้ได้ไหม คืนข้อความเหตุผลถ้าไม่ได้ */
export function refineTownDenial(zone, slot, targetLevel) {
    if (slot === "wings") {
        if (targetLevel >= WING_REFINE_FROM && zone.id !== WING_TOWN) {
            return `ตีบวกปีก +${WING_REFINE_FROM} ขึ้นไปต้องให้ช่างปีกที่ท่าเรือลอยฟ้า`;
        }
        return undefined;
    }
    if (targetLevel >= HIGH_REFINE_FROM && zone.id !== HIGH_REFINE_TOWN) {
        return `ตีบวก +${HIGH_REFINE_FROM} ขึ้นไปต้องใช้เตาถ่านแดงที่ปราการถ่านแดง`;
    }
    return undefined;
}
//# sourceMappingURL=towns.js.map